<template>
    <div class="payment-view"> <!-- bg-white mt-3 p-3 activity-type-create col-12 -->
        <b-overlay :show="loading" rounded="sm">
            <b-modal hide-footer v-model="isPaymentVisible" no-close-on-backdrop size="sm" class="pt-8" centered
                header-class="p-0" @cancel="$emit('setNewPaymentForm')"
                footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap"
                body-class="p-0">
                <template #modal-header>
                    <div class="title-block text-center p-2">
                        {{ $translate('add_payment') }}
                        <button class="close" @click="$emit('setNewPaymentForm')">
                            x
                        </button>
                    </div>
                </template>
                <template #default>
                    <!-- <b-col cols="12" class=""> -->
                    <b-card>
                        <b-card-body class="p-0 py-3">
                            <b-form class="form-sample" @submit.stop.prevent="createOrUpdate">
                                <b-row>

                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3"><strong>{{ $translate('activity') }} </strong></label>
                                        <b-form-input type="text" class="form-control" id="input-description"
                                            v-model="model.reference_no" trim readonly></b-form-input>
                                    </b-col>
                                    <!-- <b-col cols="12" md="6" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('activity') }} </strong><span
                                    class="red">*</span></label>
                            <b-form-select class="form-control" id="input-transaction_type_id"
                                v-custom-validation="$selectRequired()" v-model="model.order_id" required
                                :disabled="isUpdateMode" :options="activity">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_activity')
                                    }}</b-form-select-option>
                                </template>
</b-form-select>
</b-col> -->
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3"><strong>{{ $translate('customer') }} </strong><span
                                                class="red">*</span></label>
                                        <b-form-select class="form-control" id="input-transaction_type_id"
                                            v-custom-validation="$selectRequired()" v-model="model.customer_id" required :options="customer" disabled>
                                            <template #first>
                                                <b-form-select-option :value="null">{{ $translate('select_customer')
                                                    }}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3" for="input-transaction_date"><strong>{{ $translate('transaction_date')
                                                }}</strong></label>
                                        <b-form-input type="datetime-local" id="input-transaction_date"
                                            v-model="model.transaction_date" disabled></b-form-input>
                                    </b-col>
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3" for="input-payment_value_date"><strong>{{
            $translate('payment_value_date')
        }}</strong></label>
                                        <b-form-input type="datetime-local" id="input-payment_value_date"
                                            v-model="model.payment_value_date"></b-form-input>
                                    </b-col>
                                </b-row>


                                <b-row>
                                    <b-col cols="12" md="6" class="mt-3 dd">
                                        <label class="mb-3"><strong>{{ $translate('payment_transaction_type') }}
                                            </strong><span class="red"></span></label>
                                        <b-form-select class="form-control" id="input-officer_id"
                                            v-custom-validation="$selectRequired()" value-field="id" text-field="name"
                                            v-model="model.payment_transaction_type" :options="transaction_type">
                                            <template #first>
                                                <b-form-select-option :value="null">{{
            $translate('select_payment_transaction_type')
        }}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3"><strong>{{ $translate('payment_purpose') }} </strong><span
                                                class="red"></span></label>
                                        <b-form-select class="form-control" value-field="id" text-field="name"
                                            id="input-interaction_type_id" v-custom-validation="$selectRequired()"
                                            v-model="model.payment_purpose" :options="paymentPurpose">
                                            <template #first>
                                                <b-form-select-option :value="null">{{
            $translate('select_payment_purpose')
        }}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3"><strong>{{ $translate('external_reference_no')
                                                }}</strong></label>
                                        <b-form-input type="text" class="form-control" id="input-description"
                                            v-model="model.external_reference_no"
                                            :placeholder="$translate('enter_external_reference_no')"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3"><strong> {{ $translate('payment_type') }} </strong></label>
                                        <b-form-select class="form-control" id="input-payment_type"
                                            v-model="model.payment_type" :options="paymentTypes">
                                            <template #first>
                                                <b-form-select-option :value="null"> {{
            $translate('select_payment_type')
        }}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3"><strong>{{ $translate('payment_description')
                                                }}</strong></label>
                                        <b-form-textarea class="form-control" v-model="model.payment_description"
                                            :placeholder="$translate('enter_payment_description')"></b-form-textarea>
                                    </b-col>
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3"><strong>{{ $translate('payment_amount') }} </strong></label>
                                        <b-form-input type="number" step="0.01" min="0.01"
                                            v-model="model.payment_amount" class="form-control"
                                            :placeholder="$translate('enter_payment_amount')"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" md="6" class="mt-3 dd">
                                        <label class="mb-3"><strong>{{ $translate('payment_transaction_status')
                                                }}</strong></label>
                                        <b-form-select class="form-control" id="input-category-1" value-field="id"
                                            text-field="name" v-model="model.payment_transaction_status"
                                            :options="paymentTransactionStatus" :disabled="!allowToUpdatePayment" value="'pending'">
                                            <template #first>
                                                <!-- <b-form-select-option :value="null">
                                                    {{  $translate('select_payment_transaction_status') }}
                                                </b-form-select-option> -->
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <!-- <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('bank_code') }}</strong></label>
                        <b-form-input type="text" class="form-control" v-model="model.bank_code"
                            :placeholder="$translate('enter_bank_code')"></b-form-input>
                    </b-col> -->
                                    <b-col cols="12" md="6" class="mt-3 dd">
                                        <label class="mb-3"><strong>{{ $translate('bank_code') }} </strong></label>
                                        <b-form-select class="form-control" id="input-transaction_type_id"
                                            v-model="model.bank_id" required :options="bankcode">
                                            <template #first>
                                                <b-form-select-option :value="null">{{ $translate('select_bank_code')
                                                    }}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <!-- <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('external_gl_code') }}</strong></label>
                        <b-form-input type="text" class="form-control" v-model="model.external_gl_code"
                            :placeholder="$translate('enter_external_gl_code')"></b-form-input>
                    </b-col> -->
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3"><strong>{{ $translate('notes') }}</strong></label>
                                        <b-form-textarea class="form-control" v-model="model.notes"
                                            :placeholder="$translate('enter_notes')"></b-form-textarea>
                                    </b-col>
                                    <b-col cols="12" md="12" class="mt-3">

                                        <label class="mb-3"><strong>Attachments</strong></label>
                                        <payment-attachments :item="item" @image-selected="handleImageSelected" />


                                    </b-col>
                                </b-row>

                                <b-col md="12" class="mb-2 mt-3 text-center">
                                    <!-- <b-button v-if="hasPermissionCreate && !model.id" type="submit" class="btn btn-info btn-fw me-2"
                        variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button v-if="hasPermissionUpdate && model.id" type="submit" class="btn btn-info btn-fw me-2"
                        variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                    <b-button v-if="model.id && hasPermissionDelete" @click="deleteItem()" size="fw" class="me-2"
                        variant="delete-button">
                        {{ $deleteLabel() }}
                    </b-button>
                    <b-button variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">{{
                        $cancelLabel() }}</b-button> -->
                                    <b-button v-if="!model.id" type="submit" class="btn btn-info btn-fw me-2"
                                        variant="primary" :disabled="loading ? true : false">{{ createLabel
                                        }}</b-button>
                                    <b-button v-if="model.id" type="submit" class="btn btn-info btn-fw me-2"
                                        variant="primary" :disabled="loading ? true : false">{{ updateLabel
                                        }}</b-button>
                                    <b-button v-if="model.id" @click="deleteItem()" size="fw" class="me-2"
                                        variant="delete-button">
                                        {{ $deleteLabel() }}
                                    </b-button>
                                    <b-button variant="info" :disabled="loading ? true : false" @click="cancel()"
                                        class="btn-fw">{{
            $cancelLabel() }}</b-button>
                                </b-col>

                            </b-form>
                        </b-card-body>
                    </b-card>
                </template>
            </b-modal>
            <b-card v-if="isRoutePayment">
                    <div class="d-flex title-bar-block">
                        <div class="icon-block me-3">
                            <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                                <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="text">
                            <span class="me-2">{{ title }}</span>
                        </div>
                    </div>
                    <b-form class="form-sample" @submit.stop.prevent="createOrUpdate">
                        <b-row>

                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3"><strong>{{ $translate('activity') }} </strong></label>
                                <b-form-input type="text" class="form-control" id="input-description"
                                    v-model="model.reference_no" trim readonly></b-form-input>
                            </b-col>
                            <!-- <b-col cols="12" md="6" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('activity') }} </strong><span
                                    class="red">*</span></label>
                            <b-form-select class="form-control" id="input-transaction_type_id"
                                v-custom-validation="$selectRequired()" v-model="model.order_id" required
                                :disabled="isUpdateMode" :options="activity">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_activity')
                                    }}</b-form-select-option>
                                </template>
</b-form-select>
</b-col> -->
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3"><strong>{{ $translate('customer') }} </strong><span
                                        class="red">*</span></label>
                                <b-form-select class="form-control" id="input-transaction_type_id"
                                    v-custom-validation="$selectRequired()" v-model="model.customer_id" required :options="customer" disabled>
                                    <template #first>
                                        <b-form-select-option :value="null">{{ $translate('select_customer')
                                            }}</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3" for="datepicker1"><strong>{{ $translate('transaction_date')
                                        }}</strong></label>
                                <b-form-input type="datetime-local" id="input-transaction_date"
                                    v-model="model.transaction_date" disabled></b-form-input>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3" for="datepicker1"><strong>{{
            $translate('payment_value_date')
        }}</strong></label>
                                <b-form-input type="datetime-local" id="input-payment_value_date"
                                    v-model="model.payment_value_date"></b-form-input>
                            </b-col>
                        </b-row>


                        <b-row>
                            <b-col cols="12" md="6" class="mt-3 dd">
                                <label class="mb-3"><strong>{{ $translate('payment_transaction_type') }}
                                    </strong><span class="red"></span></label>
                                <b-form-select class="form-control" id="input-officer_id"
                                    v-custom-validation="$selectRequired()" value-field="id" text-field="name"
                                    v-model="model.payment_transaction_type" :options="transaction_type">
                                    <template #first>
                                        <b-form-select-option :value="null">{{
            $translate('select_payment_transaction_type')
        }}</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3"><strong>{{ $translate('payment_purpose') }} </strong><span
                                        class="red"></span></label>
                                <b-form-select class="form-control" value-field="id" text-field="name"
                                    id="input-interaction_type_id" v-custom-validation="$selectRequired()"
                                    v-model="model.payment_purpose" :options="paymentPurpose">
                                    <template #first>
                                        <b-form-select-option :value="null">{{
            $translate('select_payment_purpose')
        }}</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3"><strong>{{ $translate('external_reference_no')
                                        }}</strong></label>
                                <b-form-input type="text" class="form-control" id="input-description"
                                    v-model="model.external_reference_no"
                                    :placeholder="$translate('enter_external_reference_no')"></b-form-input>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3"><strong> {{ $translate('payment_type') }} </strong></label>
                                <b-form-select class="form-control" id="input-payment_type" v-model="model.payment_type"
                                    :options="paymentTypes">
                                    <template #first>
                                        <b-form-select-option :value="null"> {{
            $translate('select_payment_type')
        }}</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3"><strong>{{ $translate('payment_description')
                                        }}</strong></label>
                                <b-form-textarea class="form-control" v-model="model.payment_description"
                                    :placeholder="$translate('enter_payment_description')"></b-form-textarea>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3"><strong>{{ $translate('payment_amount') }} </strong></label>
                                <b-form-input type="number" step="0.01" min="0.01" v-model="model.payment_amount"
                                    class="form-control"
                                    :placeholder="$translate('enter_payment_amount')"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" v-if="allowToUpdatePayment" md="6" class="mt-3 dd">
                                <label class="mb-3"><strong>{{ $translate('payment_transaction_status')
                                        }}</strong></label>
                                <b-form-select  class="form-control" id="input-category-2" value-field="id"
                                    text-field="name" v-model="model.payment_transaction_status"
                                    :options="paymentTransactionStatus">
                                    <template #first>
                                        <b-form-select-option :value="null">{{
            $translate('select_payment_transaction_status')
                                            }}</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3" v-if="model.payment_transaction_status == 'cancelled'">
                                <label class="mb-3"><strong>{{ $translate('cancel_reason') }}</strong>
                                <span class="red">*</span></label>
                                <b-form-textarea type="text" class="form-control" v-model="model.cancel_reason"
                                    :placeholder="$translate('enter_cancel_reason')" required></b-form-textarea>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3 dd">
                                <label class="mb-3"><strong>{{ $translate('bank_code') }} </strong></label>
                                <b-form-select class="form-control" id="input-transaction_type_id"
                                    v-model="model.bank_id" required :options="bankcode">
                                    <template #first>
                                        <b-form-select-option :value="null">{{ $translate('select_bank_code')
                                            }}</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <!-- <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('external_gl_code') }}</strong></label>
                        <b-form-input type="text" class="form-control" v-model="model.external_gl_code"
                            :placeholder="$translate('enter_external_gl_code')"></b-form-input>
                    </b-col> -->
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3"><strong>{{ $translate('notes') }}</strong></label>
                                <b-form-textarea class="form-control" v-model="model.notes"
                                    :placeholder="$translate('enter_notes')"></b-form-textarea>
                            </b-col>
                            <b-col cols="12" md="12" class="mt-3">

                                <label class="mb-3"><strong>Attachments</strong></label>
                                <payment-attachments :item="item" @image-selected="handleImageSelected" />


                            </b-col>
                        </b-row>

                        <b-col md="12" class="mb-2 mt-3 text-center">
                            <!-- <b-button v-if="hasPermissionCreate && !model.id" type="submit" class="btn btn-info btn-fw me-2"
                        variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button v-if="hasPermissionUpdate && model.id" type="submit" class="btn btn-info btn-fw me-2"
                        variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                    <b-button v-if="model.id && hasPermissionDelete" @click="deleteItem()" size="fw" class="me-2"
                        variant="delete-button">
                        {{ $deleteLabel() }}
                    </b-button>
                    <b-button variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">{{
                        $cancelLabel() }}</b-button> -->
                            <b-button v-if="!model.id" type="submit" class="btn btn-info btn-fw me-2" variant="primary"
                                :disabled="loading ? true : false">{{ createLabel
                                }}</b-button>
                            <b-button v-if="model.id" type="submit" class="btn btn-info btn-fw me-2" variant="primary"
                                :disabled="loading ? true : false">{{ updateLabel
                                }}</b-button>
                            <!-- <b-button v-if="model.id" @click="deleteItem()" size="fw" class="me-2"
                                variant="delete-button">
                                {{ $deleteLabel() }}
                            </b-button> -->
                            <b-button variant="info" :disabled="loading ? true : false" @click="cancel()"
                                class="btn-fw">{{
                                $cancelLabel() }}</b-button>
                        </b-col>

                    </b-form>
            </b-card>
        </b-overlay>
    </div>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'
// import PaymentAttachments from './PaymentAttachments.vue'
export default {
    name: 'rentals-RentalViewItem',
    mixins: [permissionsMixins, popupMixins],
    data() {
        return {
            componentName: 'Order Type',
            flow_options: [
                { value: '1', text: 'Inbound' },
                { value: '0', text: 'Outbound' },
            ],
            entity_options: [
                { value: '0', text: 'Customer' },
                { value: '1', text: 'Officer' },
            ],
            model: {
                id: 0,
                transaction_date: new Date().toISOString().slice(0, 16), // Set transaction_date to current date and time (without seconds)
                payment_value_date: new Date().toISOString().slice(0, 16),
                order_id: null,
                customer_id: null,
                reference_no: null,
                released: null,
                payment_transaction_type: null,
                payment_purpose: null,
                external_reference_no: null,
                payment_type: null,
                payment_description: null,
                payment_amount: "",
                paid_by: "",
                payment_transaction_status: "pending",
                cancel_reason: null,
                bank_id: null,
                transaction_processed_by: null,
                notes: null,
                payment_image: "",
            },
            loading: false,
            hasErrors: false,
        }
    },
    components: {
        // PaymentAttachments
    },
    props: {
        item: Object,
        isPaymentVisible: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        title() { return this.$translate('payment') },

        isRoutePayment() {
            return this.$route.name == 'rentals'
        },

        isUpdateMode() {
            return this.model.id > 0
        },

        activity() {
            // console.log('this is state---',this.$store.state.rentals.);
            return this.$store.state.rentals.activity.map(x => ({
                value: x.id,
                text: x.reference_no,
            }));
        },
        customer() {
            console.log('customer-', this.$store.state.rentals.customer)
            return this.$store.state.rentals.customer.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        transaction_type() {
            return {
                incoming: 'Incoming',
                outgoing: 'Outgoing',
            };
        },
        paymentPurpose() {
            return {
                deposit: 'Deposit',
                job: 'Job',
                partial_payment: 'Partial Payment',
                full_payment: 'Full Payment'
            }
        },
        paymentTypes() {
            return {
                cash: "Cash",
                credit: "Credit",
                cheque: "Cheque",
                wire: "Wire"
            }
        },
        paymentTransactionStatus() {
            return {
                pending: "Pending",
                processed: "Processed",
                cancelled: "Cancelled"
            }
        },
        paymentAttachments() {
            return this.$store.state.paymentAttachmentsStore.attachments
        },
        payment() {
            return this.$store.getters['rentals/payment']
        },
        bankcode() {
            return this.$store.state.rentals.bankcode.map(x => ({
                value: x.id,
                text: x.bank_code,
            }))
        },
        allowToChangePaymentStatus() {
            return !!this.user_permissions.includes(
              "process_payment.rentals"
             );
        },
        allowToUpdatePayment() {
            return !!this.user_permissions.includes(
              "update.rentals"
             );
        },
    },
    watch: {
        'model.activity_category_id': function (val) {
            if (val == null) {
                this.$set(this.model, 'activity_template_id', null)
            }
        },
        'model.name': function (val) {
            if (val != "") {
                this.model.name = val.replace(/[^a-zA-Z ]/, '')
                this.model.name = val.replace(/\s{2,}/g, ' ')
            }
        }
    },
    async mounted() {

        // this.fetchOrders();
        await this.fetchCustomer();
        await this.fetchBank();

        if (Object.keys(this.item).length > 0) this.model = {...this.model,...this.item?.activity, ...this.item}
        console.log('this.model', this.model, this.item, this.item.length > 0)
    },
    created() {
        // this.$store.dispatch('orderTemplate/fetchAll')
        // this.$store.dispatch('checkoffTemplates/fetchAll',{})
        // this.$store.dispatch('transactionType/fetchAll')
        // this.$store.dispatch('orderCategory/fetchAll')
        // this.$store.dispatch('users/fetchAll')
        // this.$store.dispatch('interactionType/fetchAll')
    },
    methods: {
        validateInput() {
            // Replace any characters that are not letters or space with an empty string
            this.model.name = this.model.name.replace(/[^a-zA-Z\s]/g, '');

            // Remove extra spaces
            this.model.name = this.model.name.replace(/\s+/g, ' ');

            // Limit to a single space between words
            this.model.name = this.model.name.replace(/\s\s+/g, ' ');
        },
        cancel() {
            this.$emit('setNewPaymentForm')
            this.$store.commit('rentals/set_item', null)
            this.$emit('cancel')
        },
        deleteItem() {
            // Initializing key variables
            // console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'rentals/delete'
            const action = model.id ? 'update' : 'create'

            // // Generate and display confirmation prompt
            const title = this.$translate('delete_activity_type')
            const message = `${this.$translate('delete_note')} ${model.id}?`
            // const errorMsg = this.$translate('Unable_to_delete_Activity_Type')
            const alertMsg = this.$translate('delete_alert')

            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                this.$translate('deleted'),
                                action,
                                alertMsg
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
            // this.$emit(
            //     'delete-item',
            //     title,
            //     message,
            //     model.id,
            //     () => {
            //         this.$emit('success', this.$translate('deleted'))
            //     },
            //     path,
            //     errorMsg
            // )
        },

        createOrUpdate() {
            this.loading = true

            const { model, paymentAttachments: attachments } = this

            const paymentModel = { ...model, attachments }
            // const model = { ...this.model }
            console.log('model', paymentModel)

            // allow only letters and single space between words in activity type name
            // let pattern = new RegExp(/^\s*([a-zA-Z]+\s)*[a-zA-Z]+\s*$/)
            // if(!pattern.test(model.name)){
            //     this.doToast(this.$translate('error'), this.$translate('invalid_name'), 'danger')
            //     this.loading = false
            //     return false
            // }
            let $this = this;
            const path = model.id ? 'rentals/update' : 'rentals/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, paymentModel)
                        .then(() => {
                            this.loading = false
                            const message = model.id ? this.$translate('updated') : this.$translate('created')
                            $this.model = {
                                id: 0,
                                transaction_date: new Date().toISOString().slice(0, 16), // Set transaction_date to current date and time (without seconds)
                                payment_value_date: new Date().toISOString().slice(0, 16),
                                order_id: null,
                                customer_id: null,
                                reference_no: null,
                                released: null,
                                payment_transaction_type: null,
                                payment_purpose: null,
                                external_reference_no: null,
                                payment_type: null,
                                payment_description: null,
                                payment_amount: "",
                                paid_by: "",
                                payment_transaction_status: "",
                                cancel_reason: null,
                                bank_id: null,
                                external_gl_code: null,
                                transaction_processed_by: null,
                                notes: null,
                                payment_image: "",
                                ...$this.item
                            }
                            this.$emit('success', message)
                        })
                        .catch(error => {
                            console.log("error", error.message)
                            this.doToast(this.$translate('error'), error.message, 'danger')
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        async fetchOrders() {
            await this.$store.dispatch('rentals/fetchOrders');
        },
        async fetchCustomer() {
            await this.$store.dispatch('rentals/fetchCustomer');
        },
        async fetchBank() {
            await this.$store.dispatch('rentals/fetchBank');
        },
        handleImageSelected(url) {
            this.model.payment_image = url;
        }

    },
}
</script>
